import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { FormWrapper, FormWrapperProps, withTheme } from '@gn-audio/jss-components';

const SimpleFormWrapper: React.FC<FormWrapperProps> = ({ fields }: FormWrapperProps) => {
  if (fields) return <FormWrapper {...fields}></FormWrapper>;

  return null;
};
export default withDatasourceCheck()(
  withTheme({ legacyBackgroundFieldName: 'backgroundColor' })(SimpleFormWrapper)
);
